module.exports = __webpack_public_path__ + "static/media/SOLUS_LR_MARKER_281.25deg.7531fde3.png";